import React, { Component } from 'react';
import classNames from 'classnames';

import Icon, { IconType } from 'components/Icon/Icon';

import style from './Alert.module.scss';

interface Props {
  color: 'warning';
  className?: string;
}

class Alert extends Component<Props> {
  render() {
    const { color, className, children } = this.props;

    return (
      <div
        className={classNames(style.alert, color && style[color], className)}
      >
        <div className={style.icon}>
          <Icon type={this.iconType} />
        </div>
        <div className={style.content}>{children}</div>
      </div>
    );
  }

  get iconType(): IconType {
    switch (this.props.color) {
      // case 'warning': return 'warning';
      default:
        return 'info';
    }
  }
}

export default Alert;
